

const peizhis = {
  provide: [
    "北京市",
    "天津市",
    "河北省",
    "山西省",
    "内蒙古自治区",
    "辽宁省",
    "吉林省",
    "黑龙江省",
    "上海市",
    "江苏省",
    "浙江省",
    "安徽省",
    "福建省",
    "江西省",
    "山东省",
    "河南省",
    "湖北省",
    "湖南省",
    "广东省",
    "广西壮族自治区",
    "海南省",
    "重庆市",
    "四川省",
    "贵州省",
    "云南省",
    "西藏自治区",
    "陕西省",
    "甘肃省",
    "青海省",
    "宁夏回族自治区",
    "新疆维吾尔自治区",
    "台湾省",
    "香港特别行政区",
    "澳门特别行政区",
  ],
  order_status2: [
    { label: "初步审核", value: '120' },
    { label: "敏感地区待审核", value: '125' },
    { label: "待完善证件信息", value: '150' },
    { label: "照片待审核", value: '200' },
    { label: "待开卡", value: '450' },
    { label: "已领取", value: '460' },
    { label: "开卡中", value: '470' },
    { label: "待发货", value: '500' },
    { label: "已发货", value: '550' },
    { label: "已退货", value: '-700' },
    { label: "初审失败", value: '-451' },
    { label: "开卡失败", value: '-460' },
    { label: "证件不合格待重传", value: '-200' },
    { label: "订单终止", value: '0' },
  ],
  order_status: [
    { label: "订单未就绪", value: '-100' },
    { label: "订单已就绪", value: '100' },
    { label: "待解密", value: '101' },
    { label: "刷单拦截", value: '110' },
    { label: "初步审核", value: '120' },
    { label: "订单欠费", value: '122' },
    { label: "敏感地区待审核", value: '125' },
    { label: "待完善证件信息", value: '150' },
    { label: "照片待审核", value: '200' },
    { label: "待开卡", value: '450' },
    { label: "已领取", value: '460' },
    { label: "开卡中", value: '470' },
    { label: "待发货", value: '500' },
    { label: "已发货", value: '550' },
    { label: "已退货", value: '-700' },
    { label: "发货后失败", value: '-560' },
    // {label:"已激活",value:'5000'},
    { label: "初审失败", value: '-451' },
    { label: "开卡失败", value: '-460' },
    { label: "开卡失败（转单订单流转完成再进入）", value: '-46000' },
    { label: "证件不合格待重传", value: '-200' },
    { label: "订单终止", value: '0' },
  ],
  refund_status: [
    { label: "未申请退款", value: '100' },
    { label: "用户申请退款", value: '200' },
    { label: "已退款", value: '300' },
    { label: "已拒绝退款", value: '400' },
  ],
  pay_status: [
    { label: "已支付", value: '800' },
    { label: "待支付", value: '900' },
    { label: "已退款", value: '300' },
  ],
  order_status1: [
    { label: "开卡中", value: '470' },
    { label: "已发货", value: '550' },
    { label: "初审失败", value: '-451' },
    { label: "开卡失败", value: '-460' },
  ],
  active_status: [
    { label: "已激活", value: '100' },
    { label: "未激活", value: '0' },
    { label: "激活且充值", value: '200' },
  ],
  baobiao: [
    {
      value: 'anchanpin',
      label: '按产品货源统计',
      disabled: false,
      children: [
        {
          value: 'product_source',
          label: '运营商渠道'
        },
        {
          value: 'supplier',
          label: '上游供应商'
        },
        {
          value: 'product',
          label: '产品'
        },
        {
          value: 'page',
          label: '商品'
        }
      ],
    },
    {
      value: 'riqi',
      label: '按日期统计',
      disabled: false,
      children: [
        {
          value: 'day',
          label: '按日汇总'
        },
        {
          value: 'week',
          label: '按周汇总'
        },
        {
          value: 'month',
          label: '按月汇总'
        }
      ],
    },
    {
      value: 'sale_source',
      label: '按销售渠道统计',
      disabled: false,
      children: [
        // {
        //   value: 'all',
        //   label: '全部'
        // },
        {
          value: 'channels',
          label: '销售渠道'
        },
        {
          value: 'source',
          label: '订单来源'
        },
        {
          value: 'merchant',
          label: '分销商'
        }
      ],
    }

  ]
}
export default peizhis



// WEBPACK FOOTER //
// ./src/assets/peizhi.js